import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '@/ui/layout';
import { CatalogoMipView } from '@/modules/agronomia/components/CatalogoMipView';

export const Route = createFileRoute('/_authed/agronomia_/catalogo')({
  component: CatalogoMipPage,
});

function CatalogoMipPage() {
  return (
    <PageShell
      eyebrow="Agronomia"
      title="Catálogo MIP"
      lead="Pragas, doenças, daninhas e indicadores compostos com limiares de ação — base do monitoramento."
    >
      <CatalogoMipView />
    </PageShell>
  );
}
